angular.module('rjmNg.common.services').factory "connectionUtils", [
  "$q"
  "CONNECTIONS"
  "IntegrationTypes"
  "stringService"
  "INTEGRATION_CONFIGS"
  (
    $q
    CONNECTIONS
    IntegrationTypes
    stringService
    INTEGRATION_CONFIGS
  ) ->

    ERROR_MESSAGES = Object.freeze
      required: "This field is required."
      hostname: "This field must be a valid IP address or url."
      alphanumeric: "This field must be alpha-numeric."
      port: "This field must be numeric."
      name: "
        This field must be under 50 characters, and can only contain lowercase
        letters, numbers, underscores, or dollar signs. It must begin with a
        letter or an underscore. It can't be an
        <a href=\"http://docs.aws.amazon.com/redshift/latest/dg/r_pg_keywords.html\" target=\"_blank\">
        Amazon Redshift reserved word</a>."

    REGEX = Object.freeze
      port: /^[\d]+$/i
      alphanumeric: /^[\w-\.\@]*$/i
      host: /^((ht|f)tp(s?):\/\/)?((((([2][0-5][0-9]\.)|([0-1]?[0-9][0-9]?\.)){3}(([2][0-5][0-9])|([0-1]?[0-9][0-9]?))))|((\w+\.\:\@)*[a-zA-Z0-9]+\/?[\-\w\.]*))(\/?)$/i
      name: /^[a-z_]{1}[a-z0-9_\$]{0,49}$/
      subdomain: /^[a-zA-Z0-9]{1}[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]$/i
      hostwithport: /^((ht|f)tp(s?):\/\/)?((((([2][0-5][0-9]\.)|([0-1]?[0-9][0-9]?\.)){3}(([2][0-5][0-9])|([0-1]?[0-9][0-9]?))))|((\w+\.\:\@)*[a-zA-Z0-9]+\/?[\-\w\.]*))(:[\d]+)?$/i

    # The only use for this is so that we can properly translate `googlanalytics`
    # connection type that comes from the connection service for google integrations
    # into a unique type that we can use on the UI
    getConnectionType = (connection) ->
      if connection.type is 'googleanalytics'
        if connection.properties.feature is 'adwords' \
          then 'googleAdwords' \
          else 'googleEcommerce'
      else if connection.type is 'google_analytics'
        'googleAnalytics'
      else
        connection.type

    # helper function to get the UI configuration object for a certain integration type
    getUIConfig = (type) ->
      INTEGRATION_CONFIGS[type]

    getUIConfigForConnection = (connection) ->
      type = getConnectionType(connection)
      getUIConfig(type)

    getCSSClass = (type) ->
      uiConfig = getUIConfig(type)
      uiConfig?.cssClass ? type

    getCSSClassForConnection = (connection) ->
      type = getConnectionType(connection)
      getCSSClass(type)

    mergeUIConfig = (integrationTypeConfig) ->
      uiConfig = getUIConfig(integrationTypeConfig.type)
      angular.merge integrationTypeConfig, uiConfig

    getTypeFromRoute = (route) ->
      _.findKey INTEGRATION_CONFIGS, (uiConfig) ->
        uiConfig.route is route

    # returns the connection service backed configuration object for a certain integration type
    # pass an optional boolean parameter to merge in the ui configuration object
    # this function returns a promise
    getIntegrationConfig = (clientId, type, includeUIConfig = false) ->
      deferred = $q.defer()
      IntegrationTypes(clientId).getAllForClient().then (integrationTypes) ->
        integrationType = _.find integrationTypes, (integration) ->
          integration.type is type

        unless integrationType?
          return deferred.reject("No matching integration config with type #{type}")

        if includeUIConfig
          return deferred.resolve mergeUIConfig integrationType

        deferred.resolve integrationType
      , (err) ->
        deferred.reject()

      deferred.promise

    getIntegrationConfigForConnection = (clientId, connection, includeUIConfig = false) ->
      getIntegrationConfig clientId, getConnectionType(connection), includeUIConfig

    getIntegrationConfigForRoute = (clientId, route, includeUIConfig = false) ->
      getIntegrationConfig clientId, getTypeFromRoute(route), includeUIConfig

    connectionIsDatabase = (connection) ->
      type = connection?.type
      type and type in CONNECTIONS.DB_TYPES

    # Given a URL and host, returns the URL with the scheme (http:// or
    # https://) and host and path (e.g. rjmetrics.com) removed.
    stripSchemeAndHost = (url, host) ->
      schemeMatch = url.match(/^(?:http|https):\/\/(.*)/)
      if schemeMatch?
        url = schemeMatch[1]

      escapedHost = stringService.escapeRegEx(host)

      hostMatch = url.match(new RegExp("(.*)\\.#{escapedHost}(?:/.*)?$"))
      if hostMatch?
        url = hostMatch[1]

      return url

    {
      getCSSClass
      getCSSClassForConnection
      getUIConfig
      getUIConfigForConnection
      getIntegrationConfig
      getIntegrationConfigForConnection
      getIntegrationConfigForRoute
      getTypeFromRoute
      mergeUIConfig
      connectionIsDatabase
      stripSchemeAndHost
      ERROR_MESSAGES
      REGEX
    }

]
